export default "__VITE_ASSET__02c5d89b__"